<template>
  <div :class="classes()">
    <div :class="`${el}__container`">
      <Container>
        <RegisterResult :el="el" :variant="variant" :newsletterJWT="newsletterJWT" />
        <div v-if="variant > 0" :class="`${el}__box`">
          <Headline :staticClass="`${el}__boxHeadline`" size="s" responsive centered>
            {{ $t('careLevelCalculator.landingPage.trust.headline') }}
          </Headline>

          <Trustpilot type="slider" />
          <div :class="`${el}__tuev`">
            <TuevCertificate />
          </div>
        </div>
      </Container>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Container from '@/objects/Container';
import Headline from '@/objects/Headline';
import TuevCertificate from '@/objects/TuevCertificate';
import Trustpilot from '@/objects/Trustpilot';
import RegisterResult from './subcomponents/RegisterResult';

import { ROUTE_REGISTER, ROUTE_SERVICE_CARELEVEL_CALCULATOR } from '@/constants/routes';

import { ROUTE_API_GET_CARE_LEVEL_DATA_FROM_UUID } from '@/constants/apiRoutes';

import careLevelMixin from '@/mixins/careLevel';

import { mapFieldsCareLevelCalculator, mapFieldsHealth } from '@/store/mapFields';
import { CARELEVEL_REQUEST } from '@/store/actions/careLevelCalculator';
import { HEALTH_REQUEST } from '@/store/actions/health';

import {
  LS_CARE_LEVEL_CALCULATOR_JWT,
  LS_CARE_LEVEL_CALCULATOR_NEWSLETTER_TOKEN,
} from '@/constants/storage';

export default {
  name: 'CareLevelCalculatorRegister',
  props: {},
  mixins: [careLevelMixin],
  components: {
    Container,
    Headline,
    TuevCertificate,
    Trustpilot,
    RegisterResult,
  },
  computed: {
    ...mapFieldsHealth(['careLevel']),
    ...mapFieldsCareLevelCalculator(['activeWizardAnswers']),
  },
  data() {
    const newsletterJWT = localStorage.getItem(LS_CARE_LEVEL_CALCULATOR_JWT);

    return {
      newsletterJWT,
      variant: 0,
      modal: false,
      ROUTE_REGISTER,
      el: 'v-careLevelCalculatorRegister',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  mounted() {
    if (!localStorage.getItem(LS_CARE_LEVEL_CALCULATOR_NEWSLETTER_TOKEN)) {
      this.$router.push(ROUTE_SERVICE_CARELEVEL_CALCULATOR);
    } else if (this.activeWizardAnswers[0][0] !== null) {
      this.$router.go();
    }
    if (this.newsletterJWT) {
      Vue.axios
        .post(ROUTE_API_GET_CARE_LEVEL_DATA_FROM_UUID, { jwt: this.newsletterJWT })
        .then((res) => {
          const {
            module_points_json,
            calculated_care_level,
            calculated_care_level_at,
            care_level,
          } = res.data.careLevelWizard[0];

          this.$store.commit(HEALTH_REQUEST, {
            careLevel: care_level,
          });

          this.$store.dispatch(CARELEVEL_REQUEST, {
            modulePoints: module_points_json ? JSON.parse(module_points_json) : null,
            calculatedCareLevelAt: calculated_care_level_at,
            calculatedCareLevel: calculated_care_level,
          });

          this.loadVariant();
        })
        .catch(this.loadVariant);
    }
  },
  methods: {
    loadVariant() {
      setTimeout(() => {
        this.variant = this.getVariant();
      }, 1000); // Loading animation
    },

    getVariant() {
      /**
       * 1: Sie haben vermutlich einen Pflegegrad und sollten einen Antrag stellen.
       * 2: Sie haben vermutlich keinen Pflegegrad.
       * 3: Sie haben vermutlich einen höheren Pflegegrad und sollten einen Antrag stellen.
       * 4: Sie haben vermutlich keinen höheren Pflegegrad.
       */

      const { pflegegrad } = this.getCalculatedCareLevel();

      let variant = 2;

      if (pflegegrad > 0) {
        variant = 1;
      }

      if (pflegegrad === 0) {
        variant = 2;
      }

      if (this.careLevel && pflegegrad > this.careLevel) {
        variant = 3;
      }

      if (pflegegrad && this.careLevel && this.careLevel >= pflegegrad) {
        variant = 4;
      }

      return variant;
    },
  },
};
</script>
